import { render, staticRenderFns } from "./hotel-reception.vue?vue&type=template&id=355f65c4&scoped=true&"
import script from "./hotel-reception.vue?vue&type=script&lang=js&"
export * from "./hotel-reception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355f65c4",
  null
  
)

export default component.exports